
export const snakeToCamel = <T>(obj: any): T => {
  if (typeof obj !== 'object' || obj === null) {
    return obj; // Base case: return non-object values as is
  }

  if (Array.isArray(obj)) {
    // If the value is an array, recursively process each element
    return obj.map(snakeToCamel) as any;
  }

  const transformed = {};
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const value = obj[key];
      const camelKey = key.replace(/_([a-z])/g, (match, char) => char.toUpperCase());
      // @ts-ignore
      transformed[camelKey] = snakeToCamel(value); // Recursively process nested objects
    }
  }

  return transformed as T;
}

export const camelToSnake = <T>(obj: any): T => {
  if (typeof obj !== 'object' || obj === null) {
    return obj; // Base case: return non-object values as is
  }

  if (Array.isArray(obj)) {
    // If the value is an array, recursively process each element
    return obj.map(camelToSnake) as any;
  }

  const transformed = {};
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const value = obj[key];
      const snakeKey = key.replace(/[A-Z]/g, (match) => `_${match.toLowerCase()}`);
      // @ts-ignore
      transformed[snakeKey] = camelToSnake(value); // Recursively process nested objects
    }
  }

  return transformed as T;
}
